<template>
  <x-input
    v-model="showValue"
    v-bind="$attrs"
    clearable
    class="x-input--search-more"
    @change="handleChange"
    @input="handleInput"
  >
    <template #append>
      <!-- 批量查询 -->
      <el-popover
        v-model:visible="visible"
        trigger="click"
        placement="bottom"
        :width="260"
      >
        <template #reference>
          <icon-more @click="visible = !visible"></icon-more>
        </template>
        <div v-click-outside="closePopover" class="search-more--popover">
          <el-input
            v-model="text"
            :placeholder="currentMorePlaceholder"
            :disabled="disabled"
            type="textarea"
            rows="8"
          >
          </el-input>
          <div class="search-more--popover-bottom">
            <x-button size="mini" @click="handleReset">
              {{ t("el.compose.resetButtonText") }}
            </x-button>
            <div class="search-more--popover-bottom-right">
              <x-button type="minor" size="mini" @click="visible = !visible">
                {{ t("el.compose.cancelButtonText") }}
              </x-button>
              <x-button type="primary" size="mini" @click="handleSubmit">
                {{ t("el.compose.confirmButtonText") }}
              </x-button>
            </div>
          </div>
        </div>
      </el-popover>
    </template>
  </x-input>
</template>
<script lang="ts">
import { defineComponent, onMounted, computed, ref, watch } from "vue";
import { useLocale, ClickOutside } from "element-plus";
import IconMore from "../../icon/src/icon-more.vue";
import { xButton } from "../../button";
import xInput from "./input.vue";
import { searchMoreProps, searchMoreEmits } from "./search-more";

export default defineComponent({
  name: "XInputSearchMore",
  components: { xInput, IconMore, xButton },
  directives: { ClickOutside },
  props: searchMoreProps,
  emits: searchMoreEmits,
  setup(props, { emit }) {
    const { t } = useLocale();
    const text = ref("");
    const visible = ref(false);
    const showValue = ref("");
    const currentMorePlaceholder = ref(
      props.morePlaceholder || t("el.compose.morePlaceholder")
    );
    const setShowValue = () => {
      showValue.value = props.modelValue;
    };
    onMounted(() => {
      setShowValue();
    });
    watch(
      () => props.modelValue,
      () => {
        setShowValue();
      }
    );
    // 如果输入框有值
    watch(visible, (value) => {
      if (value) {
        text.value = props.modelValue
          ? props.modelValue
              .split(",")
              .filter((v) => v !== "")
              .join("\n")
          : "";
      }
    });
    const handleInput = (val: any) => {
      emit("update:modelValue", val);
    };
    const handleReset = () => {
      text.value = "";
      emit("change", []);
      emit("update:modelValue", "");
    };
    const handleSubmit = () => {
      const str = text.value
        .split("\n")
        .filter((v) => v !== "")
        .join(",");
      emit("update:modelValue", str);
      emit("change", str.split(","));
      visible.value = !visible.value;
    };
    const handleChange = (val: any) => {
      emit("change", val.split(","));
    };
    const closePopover = () => {
      visible.value = false;
    };

    return {
      text,
      visible,
      showValue,
      disabled: computed(
        () => text.value.split("\n").length > props.disabledRows
      ),
      t,
      handleInput,
      handleReset,
      handleSubmit,
      handleChange,
      currentMorePlaceholder,
      closePopover,
    };
  },
});
</script>
